import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Positioning from "@/components/Positioning";
import Approach from "@/components/Approach";
import CVReview from "@/components/CVReview";
import Standard from "@/components/Standard";
import MeetGeorge from "@/components/MeetGeorge";
import AuthorityHub from "@/components/AuthorityHub";
import ServicesSummary from "@/components/ServicesSummary";
import FoundingOffer from "@/components/FoundingOffer";
import FAQ, { faqJsonLd } from "@/components/FAQ";
import ClientProtection from "@/components/ClientProtection";
import Consultation from "@/components/LeadForm";
import Footer from "@/components/Footer";
import Seo, { orgJsonLd } from "@/lib/seo";

function AudienceBand() {
  return (
    <section data-testid="audience-band" className="bg-[#0A0A0A] border-b border-[#27272A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10 md:py-14">
        <p className="font-body text-lg md:text-xl text-[#F8F8F5] leading-relaxed max-w-4xl">
          Career strategy, CV and LinkedIn support for{" "}
          <span className="text-[#DFFF00]">people seeking work, changing careers, graduating, moving to Australia or exploring a small business.</span>
        </p>
      </div>
    </section>
  );
}

function InterviewVisual() {
  return (
    <section data-testid="interview-visual" className="bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-28 md:pt-32 pb-4 md:pb-6">
        <img
          src="/interview-panel.jpg"
          alt="Professional job interview panel meeting with a candidate"
          data-testid="interview-panel-image"
          className="w-full h-auto rounded-[20px] shadow-[0_24px_60px_rgba(0,0,0,0.45)]"
        />
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <main className="bg-[#0A0A0A] text-[#F8F8F5]">
      <Seo
        title="Barrett Career Brand — Career Strategy, CV and LinkedIn Support Australia"
        description="Whether you are looking for a job, changing direction or exploring a small business, Barrett Career Brand helps you explain what you offer and plan your next step. Start with a free CV assessment."
        path="/"
        jsonLd={[orgJsonLd, faqJsonLd]}
      />
      <Nav />
      <InterviewVisual />
      <Hero />
      <Marquee />
      <AudienceBand />
      <Positioning />
      <Approach />
      <CVReview />
      <Standard />
      <MeetGeorge />
      <AuthorityHub />
      <ServicesSummary />
      <FoundingOffer />
      <FAQ />
      <ClientProtection />
      <Consultation />
      <Footer />
    </main>
  );
}
